import Form from './Form.vue'
import FormItem from './FormItem.vue'
import FormInput from './FormInput.vue'
import FormTextarea from './FormTextarea.vue'
// import FormSelect from './FormSelect.vue'
import FormCheckbox from './FormCheckbox.vue'
import FormDatePicker from './FormDatePicker.vue'
import CustomSelect from './CustomSelect.vue'
import FormSelect from './CustomFormSelect.vue'
import Switch from './Switch.vue'
import FormSwitch from './FormSwitch.vue'

export {
  Form,
  FormItem,
  FormInput,
  FormTextarea,
  FormSelect,
  FormCheckbox,
  FormDatePicker,
  CustomSelect,
  Switch,
  FormSwitch,
}

export default {
  install(app) {
    app.component('ScanatForm', Form)
    app.component('ScanatFormItem', FormItem)
    app.component('ScanatFormInput', FormInput)
    app.component('ScanatFormTextarea', FormTextarea)
    app.component('ScanatFormSelect', FormSelect)
    app.component('ScanatFormCheckbox', FormCheckbox)
    app.component('FormDatePicker', FormDatePicker)
    app.component('ScanatCustomSelect', CustomSelect)
    app.component('ScanatSwitch', Switch)
    app.component('ScanatFormSwitch', FormSwitch)
  }
} 